import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { reportsModel } from '../Axios/AxiosConfig';
import { getUserDetails } from '../Auth/AuthUtil';

const ReportStore = create(
    persist(
        (set, get) => ({
            Reports: [],

            isReportsLoading: true,

            AIReports: [],

            isAIReportsLoading: true,

            aiParameters: [],

            getReports: async (UID) => {
                try {

                    const response = await reportsModel.get(`/GetReports/${UID}`);
                    if (response.status === 200) {
                        set({
                            Reports: response?.data || [],
                            isReportsLoading: false,
                        });
                    }
                } catch (err) {
                    console.log("Error fetching reports:", err?.response?.data || err.message);
                    set({ isReportsLoading: false });
                }
            },

            setAiParameters: (dataOrUpdater) =>
                set((state) => ({
                    aiParameters:
                        typeof dataOrUpdater === 'function'
                            ? dataOrUpdater(state.aiParameters)
                            : dataOrUpdater,
                })),

            getAIReports: async (UID, appointmentId) => {
                try {
                    const response = await reportsModel.post(`/GetAIReports`, {
                        UID,
                        appointmentId,
                    });

                    if (response.status === 200) {
                        const { data } = response;

                        const flatParams = data?.flatMap((reportItem) =>
                            reportItem?.Reports.flatMap((report) => {
                                try {
                                    const analysis = JSON?.parse(report?.ai_analysis || "{}");
                                    const abnormal = analysis?.abnormal_parameters || [];
                                    // const normal = analysis.normal_parameters || [];

                                    return [
                                        ...abnormal.map((p) => ({
                                            ...p,
                                            type: "abnormal",
                                            goal: false,
                                        })),
                                        // ...normal.map((p) => ({ ...p, type: "normal", goal: false })),
                                    ];
                                } catch (e) {
                                    return [];
                                }
                            })
                        );

                        set({
                            AIReports: data,
                            isAIReportsLoading: false,
                            aiParameters: flatParams,
                        });
                    }
                } catch (err) {
                    console.log("Error fetching AI reports:", err?.response?.data || err.message);
                    set({ isAIReportsLoading: false });
                }
            },

            deletereport: async (id) => {
                try {
                    const deleteResponse = await reportsModel.delete(`/DeleteReport/${id}`);
                    if (deleteResponse.status === 200) {
                        set((state) => ({
                            Reports: state.Reports.filter((report) => report._id !== id && report.ReportId !== id),
                            AIReports: state.AIReports.filter((report) => report._id !== id && report.ReportId !== id)
                        }));
                    }
                } catch (err) {
                    console.log("Error deleting report:", err?.response?.data || err.message);
                }
            },

            clearReportsStore: () => {
                set({
                    Reports: [],
                    isReportsLoading: true,
                    AIReports: [],
                    isAIReportsLoading: true,
                    aiParameters: [],
                });
            }

        }),
        {
            name: 'ReportsStore',
            getStorage: () => sessionStorage,
        }
    )
);

export default ReportStore;
